import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-page-not-found-404',
    imports: [RouterLink],
    templateUrl: './page-not-found-404.component.html',
    styleUrl: './page-not-found-404.component.scss'
})
export class PageNotFound404Component {}
